import { ICourse } from '@/interfaces/course';

import { post } from './api';

export enum enEventNames {
  communityViewed = 'community_viewed'
}

interface IWebhookParams {
  eventName: enEventNames;
  course: ICourse;
}

const sendWebhookLog = ({ eventName, course }: IWebhookParams) => {
  return post({
    url: '/webhook/trigger',
    data: {
      eventName,
      course,
      producer: course.producer
    }
  });
};

export const viewCommunity = (course: ICourse) => {
  sendWebhookLog({ course, eventName: enEventNames.communityViewed });
};
